import { CartLinesUpdateEvent } from '@shopify/events';

const ROOT_SELECTOR = [
  '[data-cx]','[data-wc]','[data-ch]','[data-cr]','[data-es]','[data-kc]',
  '[data-ke]','[data-lc]','[data-pl]','[data-br]','[data-wb]','[data-wa-pdp]',
  '[data-wkp]','[data-wxm]','[data-wkc]','[data-wam]','[data-wci]'
].join(',');

const LOGO_FEE = Object.freeze({ id: '52199112573218', cents: 3500 });

async function openCartAfterAdd() {
  const cartRoute = window.Theme?.routes?.cart_url || '/cart';
  const [cartResponse, sectionsResponse] = await Promise.all([
    fetch(`${cartRoute}.js`, { headers: { Accept: 'application/json' } }),
    fetch(`${cartRoute}?sections=cart-drawer-section`, { headers: { Accept: 'application/json' } }),
  ]);

  if (!cartResponse.ok || !sectionsResponse.ok) throw new Error('Nao foi possivel atualizar o carrinho.');

  const [ajaxCart, sections] = await Promise.all([cartResponse.json(), sectionsResponse.json()]);
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [],
    promise: deferred.promise,
  }));

  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
    detail: {
      items: ajaxCart.items,
      source: 'weart-product-system',
      itemCount: ajaxCart.item_count,
      sections,
      didError: false,
    },
  });

  const openDrawer = () => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer?.isOpen || drawer?.hasAttribute('open')) return true;
    if (typeof drawer?.open === 'function') {
      drawer.open();
      return true;
    }
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger instanceof HTMLElement) {
      trigger.click();
      return true;
    }
    if (typeof drawer?.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  };

  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const opened = openDrawer();
  await new Promise((resolve) => setTimeout(resolve, 350));
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer?.isOpen && !drawer?.hasAttribute('open')) openDrawer();
  if (!opened && !drawer?.isOpen && !drawer?.hasAttribute('open')) window.location.href = cartRoute;

  return ajaxCart;
}

window.WeArtCart = Object.freeze({ openAfterAdd: openCartAfterAdd });

const RADIO_GROUP_SELECTOR = [
  '[class$="-opts"]','[class$="-opts2"]','[class$="-bases"]','[class$="-cores"]',
  '[class$="-radios"]','[class$="-kits"]','[class$="-tipos"]','[class$="-estilos"]',
  '[class$="-fontes"]','[class$="-opcoes"]','[class$="-options"]'
].join(',');

const RADIO_BUTTON_SELECTOR = [
  'button[class*="-opt"]','button[class*="-base"]','button[class*="-radio"]',
  'button[class*="-cor"]','button[class*="-est"]','button[class*="-fonte"]',
  'button[class*="-tipo"]','button[class*="-kit"]'
].join(',');

const UPLOAD_ICON_SELECTOR = [
  '.cx-upload__icon','.wc-upload__ico','.ch-upload__ico','.cr-upload__ico',
  '.lc-upload__ico','.wa-upload__ico','.wkp-upload__ico','.wxm-upload__ico'
].join(',');

const GALLERY_SELECTOR = [
  '.cx-preview','.wc-gal','.ch-gal','.cr-preview','.es-gal','.kc-preview',
  '.ke-preview','.lc-gal','.pl-preview','.br-preview','.wb-gal','.wa-gallery',
  '.wkp-gallery','.wxm-gallery','.wkc-gallery','.wam-gallery','.wci-gallery'
].join(',');

const BUYBOX_SELECTOR = [
  '.cx-buybox','.wc-buybox','.ch-buybox','.cr-buybox','.es-buybox','.kc-buybox',
  '.ke-buybox','.lc-buybox','.pl-buybox','.br-buybox','.wb-buybox','.wa-buybox',
  '.wkp-buybox','.wxm-buybox','.wkc-buybox','.wam-buybox','.wci-buybox'
].join(',');

function initializeClinicIndividual(root) {
  if (!root.matches('[data-wci]') || root.dataset.wciReady === 'true') return;
  root.dataset.wciReady = 'true';
  const product = JSON.parse(root.querySelector('[data-wci-product]').textContent);
  const isClipboard = root.dataset.wciClipboard === 'true';
  const isTrash = root.dataset.wciTrash === 'true';
  const isDescarpack = root.dataset.wciDescarpack === 'true';
  const isAcrylicOrganizer = root.dataset.wciAcrylicOrganizer === 'true';
  const isConsolidatedTray = root.dataset.wciConsolidatedTray === 'true';
  const isConsolidatedPot = root.dataset.wciConsolidatedPot === 'true';
  const isConsolidatedClipboard = root.dataset.wciConsolidatedClipboard === 'true';
  const isAcrylicProduct = root.dataset.wciAcrylicProduct === 'true';
  const isPerfumery = root.dataset.wciPerfumery === 'true';
  const isConsolidated = isConsolidatedTray || isConsolidatedPot || isConsolidatedClipboard;
  const state = {
    mode: 'Nome ou iniciais',
    size: root.dataset.wciDescarpack === 'true' ? '1,5 L' : '',
    variantSize: isConsolidatedTray ? 'P' : isConsolidatedPot ? 'Pequeno' : isConsolidatedClipboard ? 'A5' : '',
    variantLabel: (isConsolidatedTray || isConsolidatedPot) ? 'P' : isConsolidatedClipboard ? 'A5' : '',
    acrylicColor: (isClipboard || isTrash || isDescarpack || isAcrylicOrganizer) ? 'Branco' : '',
    clipFinish: isClipboard ? 'Dourado' : '',
    engravingColor: (isTrash || isDescarpack || isAcrylicOrganizer) ? 'Dourado' : '',
    pullColor: isTrash ? 'Dourado' : '',
    perfumeryFinish: isPerfumery ? 'Dourado' : ''
  };
  const error = root.querySelector('[data-wci-error]');
  const file = root.querySelector('[data-wci-file]');
  const money = (cents) => (Number(cents) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const currentVariant = () => {
    if (isDescarpack) {
      const capacity = state.size === '1,5 L' ? '1.5 L' : state.size;
      return product.variants?.find((variant) => variant.size === capacity) || product.variants?.[0] || { id: product.variantId, available: product.available };
    }
    if (!isConsolidated) return product.variants?.[0] || { id: product.variantId, available: product.available };
    return product.variants?.find((variant) => variant.size === state.variantSize) || product.variants?.[0] || { id: product.variantId, available: product.available };
  };

  const engravingColors = {
    Dourado: '#a87924',
    Prata: '#8b9098',
    'Rosé': '#b66f79',
    Preto: '#242424',
    Branco: '#ffffff',
    'Azul Marinho': '#17243e'
  };

  function showPreviewView(view) {
    if (!isAcrylicProduct) return;
    const personalization = root.querySelector('[data-wci-personalization-preview]');
    const productPreview = root.querySelector('[data-wci-product-preview]');
    const showPersonalization = view === 'personalization';
    if (personalization) personalization.hidden = !showPersonalization;
    if (productPreview) productPreview.hidden = showPersonalization;
    root.querySelectorAll('[data-wci-view]').forEach((button) => {
      const selected = button.dataset.wciView === view;
      button.classList.toggle('is-on', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  }

  function updatePersonalizationPreview() {
    if (!isAcrylicProduct) return;
    const line1 = root.querySelector('[data-wci-line1]')?.value.trim() || '';
    const line2 = root.querySelector('[data-wci-line2]')?.value.trim() || '';
    const copy = root.querySelector('[data-wci-preview-copy]');
    const previewLine1 = root.querySelector('[data-wci-preview-line1]');
    const previewLine2 = root.querySelector('[data-wci-preview-line2]');
    const engraving = isClipboard ? state.clipFinish : state.engravingColor;
    const isLogo = state.mode === 'Logo';
    if (previewLine1) previewLine1.textContent = isLogo ? 'SUA LOGO' : (line1 || 'Seu nome');
    if (previewLine2) {
      previewLine2.textContent = isLogo ? 'Arte ajustada e aprovada antes da produção' : (line2 || 'Sua especialidade');
      previewLine2.hidden = isTrash;
    }
    if (copy) {
      copy.style.setProperty('--wci-engraving-color', engravingColors[engraving] || engravingColors.Dourado);
      copy.dataset.wciLightEngraving = String(engraving === 'Branco' || engraving === 'Prata');
    }
  }

  function updateAcrylicPreview(button = root.querySelector('[data-wci-acrylic-color].is-on')) {
    if (!button) return;
    let source = button.dataset.wciPreview;
    if (isConsolidatedPot) source = state.variantSize === 'Grande' ? button.dataset.wciPreviewLarge : button.dataset.wciPreviewSmall;
    if (isClipboard && state.clipFinish === 'Prata' && button.dataset.wciPreviewClipPrata) source = button.dataset.wciPreviewClipPrata;
    if (isClipboard && state.clipFinish === 'Rosé' && button.dataset.wciPreviewClipRose) source = button.dataset.wciPreviewClipRose;
    if (isTrash && state.pullColor === 'Prata') source = source?.replace(/wci-lixeira-(?!prata-)/, 'wci-lixeira-prata-');
    if (!source) return;
    const main = root.querySelector('[data-wci-product-preview]');
    const summaryImage = root.querySelector('[data-wci-summary-image]');
    const productThumb = root.querySelector('[data-wci-product-thumb]');
    const plate = root.querySelector('[data-wci-plate]');
    const plateThumb = root.querySelector('[data-wci-plate-thumb]');
    main?.removeAttribute('srcset');
    main?.removeAttribute('sizes');
    if (main) {
      main.src = source;
      main.alt = `${product.title} em acrílico ${state.acrylicColor.toLowerCase()}`;
    }
    if (summaryImage) summaryImage.src = source;
    if (productThumb) productThumb.src = source;
    if (button.dataset.wciPlate) {
      if (plate) {
        plate.src = button.dataset.wciPlate;
        plate.alt = `Prévia da personalização em acrílico ${state.acrylicColor.toLowerCase()}`;
      }
      if (plateThumb) plateThumb.src = button.dataset.wciPlate;
    }
  }

  function setMode(button) {
    state.mode = button.dataset.wciMode;
    root.querySelectorAll('[data-wci-mode]').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-on', selected);
      item.setAttribute('aria-checked', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    const textFields = root.querySelector('[data-wci-text]');
    const logoFields = root.querySelector('[data-wci-logo]');
    if (textFields) textFields.hidden = state.mode === 'Logo';
    if (logoFields) logoFields.hidden = state.mode !== 'Logo';
    updatePersonalizationPreview();
    if (isAcrylicProduct) showPreviewView('personalization');
    updateSummary();
  }

  function updateSummary() {
    const choices = [state.variantLabel, state.size, state.mode].filter(Boolean);
    if (state.mode === 'Logo' && file?.files[0]) choices.push(file.files[0].name);
    if (state.mode !== 'Logo') {
      const line1 = root.querySelector('[data-wci-line1]')?.value.trim() || '';
      const line2 = root.querySelector('[data-wci-line2]')?.value.trim() || '';
      const initials = root.querySelector('[data-wci-initials]')?.value.trim() || '';
      if (line1) choices.push(line1);
      if (line2) choices.push(line2);
      if (initials) choices.push(`Iniciais: ${initials}`);
    }
    if (isClipboard) {
      choices.push(`Acrílico: ${state.acrylicColor}`, `Clipe e gravação: ${state.clipFinish}`);
    } else if (isTrash) {
      choices.push(`Acrílico: ${state.acrylicColor}`, `Gravação: ${state.engravingColor}`, `Puxador: ${state.pullColor}`);
    } else if (isDescarpack || isAcrylicOrganizer) {
      choices.push(`Acrílico: ${state.acrylicColor}`, `Gravação: ${state.engravingColor}`);
    } else if (isPerfumery) {
      choices.push(`Acabamento: ${state.perfumeryFinish}`);
      const fragrance = root.querySelector('[data-wci-fragrance]')?.value.trim() || '';
      if (fragrance) choices.push(`Fragrância: ${fragrance}`);
    } else {
      const finish = root.querySelector('[data-wci-finish]')?.value.trim() || '';
      if (finish) choices.push(finish);
    }
    root.querySelector('[data-wci-summary]').textContent = choices.join(' · ');
    const variant = currentVariant();
    const total = Number(variant.price) + (state.mode === 'Logo' ? LOGO_FEE.cents : 0);
    root.querySelectorAll('[data-wci-price]').forEach((price) => { price.textContent = money(total); });
  }

  function fail(message, element) {
    error.textContent = message;
    error.hidden = false;
    element?.setAttribute?.('aria-invalid', 'true');
    element?.focus?.();
    element?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  }

  root.querySelectorAll('[data-wci-mode]').forEach((button) => button.addEventListener('click', () => setMode(button)));
  root.querySelectorAll('[data-wci-size]').forEach((button) => button.addEventListener('click', () => {
    state.size = button.dataset.wciSize;
    root.querySelectorAll('[data-wci-size]').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-on', selected);
      item.setAttribute('aria-checked', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    updateSummary();
  }));
  root.querySelectorAll('[data-wci-variant-size]').forEach((button) => button.addEventListener('click', () => {
    state.variantSize = button.dataset.wciVariantSize;
    state.variantLabel = button.dataset.wciVariantLabel || state.variantSize;
    root.querySelectorAll('[data-wci-variant-size]').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-on', selected);
      item.setAttribute('aria-checked', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    updateAcrylicPreview();
    showPreviewView('product');
    updateSummary();
  }));
  function bindChoice(selector, stateKey, dataKey, onChange) {
    root.querySelectorAll(selector).forEach((button) => button.addEventListener('click', () => {
      state[stateKey] = button.dataset[dataKey];
      root.querySelectorAll(selector).forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-on', selected);
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      onChange?.(button);
      updateSummary();
    }));
  }
  bindChoice('[data-wci-acrylic-color]', 'acrylicColor', 'wciAcrylicColor', (button) => {
    updateAcrylicPreview(button);
    showPreviewView('product');
  });
  bindChoice('[data-wci-clip-finish]', 'clipFinish', 'wciClipFinish', () => {
    updateAcrylicPreview();
    updatePersonalizationPreview();
    showPreviewView('product');
  });
  bindChoice('[data-wci-engraving-color]', 'engravingColor', 'wciEngravingColor', () => {
    updatePersonalizationPreview();
    showPreviewView('personalization');
  });
  bindChoice('[data-wci-pull-color]', 'pullColor', 'wciPullColor', () => {
    updateAcrylicPreview();
    showPreviewView('product');
  });
  bindChoice('[data-wci-perfumery-finish]', 'perfumeryFinish', 'wciPerfumeryFinish', () => {
    const media = root.querySelector(`[data-wci-perfumery-media="${CSS.escape(state.perfumeryFinish)}"]`);
    media?.click();
  });
  root.querySelectorAll('input,textarea').forEach((control) => control.addEventListener('input', updateSummary));
  root.querySelectorAll('[data-wci-line1],[data-wci-line2]').forEach((control) => {
    control.addEventListener('focus', () => showPreviewView('personalization'));
    control.addEventListener('input', () => {
      updatePersonalizationPreview();
      showPreviewView('personalization');
    });
  });
  file?.addEventListener('change', () => {
    root.querySelector('[data-wci-filename]').textContent = file.files[0]?.name || 'Nenhum arquivo selecionado';
    updateSummary();
    updatePersonalizationPreview();
    showPreviewView('personalization');
  });
  root.querySelectorAll('[data-wci-view]').forEach((button) => button.addEventListener('click', () => showPreviewView(button.dataset.wciView)));
  root.querySelectorAll('[data-wci-image]').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('.wci-thumb').forEach((item) => item.classList.toggle('is-on', item === button));
    const image = root.querySelector('[data-wci-product-preview]');
    image.src = button.dataset.wciImage;
    image.alt = button.dataset.wciAlt;
    if (isAcrylicProduct) {
      image.hidden = false;
      root.querySelector('[data-wci-personalization-preview]').hidden = true;
    }
  }));

  root.querySelector('[data-wci-add]').addEventListener('click', async function () {
    error.hidden = true;
    const variant = currentVariant();
    if (!variant.available) return fail('Esta opção está temporariamente indisponível.', this);
    const line1 = root.querySelector('[data-wci-line1]').value.trim();
    if (state.mode === 'Logo' && !file?.files.length) return fail('Selecione o arquivo da logo.', file);
    if (state.mode !== 'Logo' && !line1) return fail('Preencha o nome ou a primeira linha.', root.querySelector('[data-wci-line1]'));
    const confirmation = root.querySelector('[data-wci-confirm]');
    if (!confirmation.checked) return fail('Confirme a revisão da configuração.', confirmation);

    const form = new FormData();
    const isLogo = state.mode === 'Logo';
    const propertyRoot = isLogo ? 'items[0][properties]' : 'properties';
    const appendProperty = (name, value) => form.append(`${propertyRoot}[${name}]`, value);
    if (isLogo) {
      form.append('items[0][id]', String(variant.id));
      form.append('items[0][quantity]', '1');
      form.append('items[1][id]', LOGO_FEE.id);
      form.append('items[1][quantity]', '1');
      form.append('items[1][properties][Serviço]', 'Tratamento profissional da logo');
      form.append('items[1][properties][Aplicado a]', product.title);
    } else {
      form.append('id', String(variant.id));
      form.append('quantity', '1');
    }
    if (state.variantLabel) appendProperty('Tamanho', state.variantLabel);
    if (state.size) appendProperty('Capacidade do coletor', state.size);
    appendProperty('Tipo de personalização', state.mode);
    if (isLogo) appendProperty('Arquivo da logo', file.files[0]);
    else {
      appendProperty((isTrash || isDescarpack || isAcrylicOrganizer) ? 'Primeiro nome ou iniciais' : 'Nome ou primeira linha', line1);
      const line2 = root.querySelector('[data-wci-line2]')?.value.trim() || '';
      const initials = root.querySelector('[data-wci-initials]')?.value.trim() || '';
      if (line2) appendProperty('Segunda linha', line2);
      if (initials) appendProperty('Iniciais', initials);
    }
    const finish = root.querySelector('[data-wci-finish]')?.value.trim() || '';
    const notes = root.querySelector('[data-wci-notes]')?.value.trim() || '';
    if (isClipboard) {
      appendProperty('Cor do acrílico', state.acrylicColor);
      appendProperty('Cor do clipe e gravação', state.clipFinish);
    } else if (isTrash) {
      appendProperty('Cor do acrílico', state.acrylicColor);
      appendProperty('Cor da gravação', state.engravingColor);
      appendProperty('Cor do puxador simples', state.pullColor);
    } else if (isDescarpack || isAcrylicOrganizer) {
      appendProperty('Cor do acrílico', state.acrylicColor);
      appendProperty('Cor da gravação', state.engravingColor);
    } else if (isPerfumery) {
      appendProperty('Acabamento metálico', state.perfumeryFinish);
      appendProperty('Gravação', 'Permanente a laser, sem pintura');
      const fragrance = root.querySelector('[data-wci-fragrance]')?.value.trim() || '';
      if (fragrance) appendProperty('Preferência de fragrância', fragrance);
    } else if (finish) appendProperty('Preferência de acabamento ou cor', finish);
    if (notes) appendProperty('Observações', notes);

    const button = this;
    button.disabled = true;
    button.textContent = 'Adicionando…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: form, headers: { Accept: 'application/json' } });
      if (!response.ok) {
        const payload = await response.json();
        throw new Error(payload.description || `Não foi possível adicionar ${product.title}.`);
      }
      await window.WeArtCart.openAfterAdd();
    } catch (cause) {
      fail(cause.message || 'Não foi possível adicionar o produto.', button);
    } finally {
      button.disabled = false;
      button.textContent = 'Adicionar ao carrinho';
    }
  });
  updateAcrylicPreview();
  updatePersonalizationPreview();
  if (isPerfumery) root.querySelector('[data-wci-perfumery-media="Dourado"]')?.click();
  updateSummary();
}

function initializeMirror(root) {
  if (!root.matches('[data-wam]') || root.hasAttribute('data-wam-live') || root.dataset.wamReady === 'true') return;
  root.dataset.wamReady = 'true';
  const variants = JSON.parse(root.querySelector('[data-wam-variants]').textContent);
  const state = { model: 'Minimalista', size: 'Pequeno', color: '', mode: 'Nome ou iniciais' };
  const money = cents => (cents / 100).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
  const main = root.querySelector('[data-wam-main]');
  const colors = root.querySelector('[data-wam-colors]');
  const error = root.querySelector('[data-wam-error]');
  const dimensions = {
    Minimalista: {Pequeno:'25 × 12 cm',Grande:'33 × 20 cm'},
    Vanity: {Pequeno:'25 × 12 cm',Grande:'33 × 20 cm'},
    Redondo: {Pequeno:'25 × 12 cm',Grande:'31 × 15 cm'},
    Rainha: {Pequeno:'25 × 12 cm',Grande:'33 × 20 cm'},
    Coração: {Pequeno:'25 × 12 cm',Grande:'33 × 20 cm'}
  };
  const matches = variant => variant.options[0] === state.model && variant.options[1] === state.color && variant.options[2] === state.size;
  const current = () => variants.find(matches);
  const setSelected = (selector, active) => root.querySelectorAll(selector).forEach(button => {
    const on = button === active;
    button.classList.toggle('is-on', on);
    button.setAttribute('aria-checked', String(on));
    button.tabIndex = on ? 0 : -1;
  });
  function availableColors() {
    return [...new Set(variants.filter(v => v.options[0] === state.model && v.options[2] === state.size).map(v => v.options[1]))];
  }
  function renderColors() {
    const list = availableColors();
    if (!list.includes(state.color)) state.color = list[0] || '';
    colors.innerHTML = list.map(color => `<button type="button" class="wam-color${color === state.color ? ' is-on' : ''}" data-wam-color="${color}" role="radio" aria-checked="${color === state.color}"><span aria-hidden="true"></span><strong>${color}</strong></button>`).join('');
    colors.querySelectorAll('[data-wam-color]').forEach(button => button.addEventListener('click', () => { state.color = button.dataset.wamColor; setSelected('[data-wam-color]', button); update(); }));
  }
  function update() {
    const variant = current();
    const modelButton = root.querySelector(`[data-wam-model="${CSS.escape(state.model)}"]`);
    if (modelButton) {
      main.src = modelButton.dataset.image;
      main.alt = `Espelho de mão personalizado modelo ${state.model}`;
      root.querySelector('[data-wam-summary-image]').src = modelButton.dataset.image;
    }
    root.querySelectorAll('[data-wam-size-note]').forEach(note => note.textContent = dimensions[state.model][note.dataset.wamSizeNote]);
    const total = variant ? Number(variant.price) + (state.mode === 'Logo' ? LOGO_FEE.cents : 0) : 0;
    root.querySelector('[data-wam-price]').textContent = variant ? money(total) : 'Combinação indisponível';
    root.querySelector('[data-wam-total]').textContent = variant ? money(total) : '';
    root.querySelector('[data-wam-summary]').textContent = [state.model,state.size,state.color,state.mode,root.querySelector('[data-wam-engraving]').value].filter(Boolean).join(' · ');
    root.querySelector('[data-wam-add]').disabled = !variant || !variant.available;
  }
  root.querySelectorAll('[data-wam-model]').forEach(button => button.addEventListener('click', () => { state.model = button.dataset.wamModel; setSelected('[data-wam-model]', button); renderColors(); update(); }));
  root.querySelectorAll('[data-wam-size]').forEach(button => button.addEventListener('click', () => { state.size = button.dataset.wamSize; setSelected('[data-wam-size]', button); renderColors(); update(); }));
  root.querySelectorAll('[data-wam-mode]').forEach(button => button.addEventListener('click', () => { state.mode = button.dataset.wamMode; setSelected('[data-wam-mode]', button); root.querySelector('[data-wam-text-fields]').hidden = state.mode === 'Logo'; root.querySelector('[data-wam-logo-fields]').hidden = state.mode !== 'Logo'; update(); }));
  root.querySelectorAll('[data-wam-thumb]').forEach(button => button.addEventListener('click', () => { root.querySelectorAll('[data-wam-thumb]').forEach(x => x.classList.toggle('is-on', x === button)); main.src = button.dataset.wamThumb; main.alt = button.dataset.alt; }));
  root.querySelector('[data-wam-engraving]').addEventListener('change', update);
  const file = root.querySelector('[data-wam-logo]');
  file.addEventListener('change', () => { root.querySelector('[data-wam-filename]').textContent = file.files[0]?.name || 'Nenhum arquivo selecionado'; });
  function fail(message, element) { error.textContent = message; error.hidden = false; element?.focus(); element?.scrollIntoView({behavior:'smooth',block:'center'}); }
  root.querySelector('[data-wam-add]').addEventListener('click', async function() {
    error.hidden = true;
    const variant = current();
    if (!variant) return fail('Esta combinação não está disponível. Escolha outra opção.', colors);
    const line1 = root.querySelector('[data-wam-line1]').value.trim();
    if (state.mode !== 'Logo' && !line1) return fail('Preencha o texto principal da personalização.', root.querySelector('[data-wam-line1]'));
    if (state.mode === 'Logo' && !file.files.length) return fail('Selecione o arquivo da logo.', file);
    if (!root.querySelector('[data-wam-confirm]').checked) return fail('Confirme a revisão da configuração.', root.querySelector('[data-wam-confirm]'));
    const form = new FormData();
    const isLogo = state.mode === 'Logo';
    const propertyRoot = isLogo ? 'items[0][properties]' : 'properties';
    const appendProperty = (name, value) => form.append(`${propertyRoot}[${name}]`, value);
    if (isLogo) {
      form.append('items[0][id]', variant.id);
      form.append('items[0][quantity]', '1');
      form.append('items[1][id]', LOGO_FEE.id);
      form.append('items[1][quantity]', '1');
      form.append('items[1][properties][Serviço]', 'Tratamento profissional da logo');
      form.append('items[1][properties][Aplicado a]', 'Espelho de mão personalizado');
    } else {
      form.append('id', variant.id);
      form.append('quantity', '1');
    }
    appendProperty('Tipo de personalização', state.mode);
    appendProperty('Cor da gravação', root.querySelector('[data-wam-engraving]').value);
    if (isLogo) appendProperty('Arquivo da logo', file.files[0]);
    else {
      appendProperty('Texto principal', line1);
      const line2 = root.querySelector('[data-wam-line2]').value.trim();
      const initials = root.querySelector('[data-wam-initials]').value.trim();
      if (line2) appendProperty('Segunda linha', line2);
      if (initials) appendProperty('Iniciais', initials);
    }
    const notes = root.querySelector('[data-wam-notes]').value.trim();
    if (notes) appendProperty('Observações', notes);
    const button = this;
    button.disabled = true;
    button.textContent = 'Adicionando…';
    try {
      const response = await fetch('/cart/add.js', {method:'POST',body:form,headers:{Accept:'application/json'}});
      if (!response.ok) { const payload = await response.json(); throw new Error(payload.description || 'Não foi possível adicionar o espelho.'); }
      await window.WeArtCart.openAfterAdd();
    } catch (cause) { fail(cause.message || 'Não foi possível adicionar o espelho.', button); }
    finally { button.disabled = false; button.textContent = 'Adicionar ao carrinho'; }
  });
  renderColors();
  update();
}

const uploadIcon = `
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v4.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V14"
      stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

function isSelected(button) {
  return button.classList.contains('is-active') || button.classList.contains('is-on');
}

function syncRadioGroup(group) {
  const buttons = [...group.querySelectorAll(RADIO_BUTTON_SELECTOR)]
    .filter((button) => button.closest(RADIO_GROUP_SELECTOR) === group);
  if (buttons.length < 2) return;

  group.setAttribute('role', 'radiogroup');
  if (!group.getAttribute('aria-label')) {
    const label = group.previousElementSibling?.textContent?.trim().replace(/\s+/g, ' ');
    group.setAttribute('aria-label', label || 'Escolha uma opção');
  }

  buttons.forEach((button, index) => {
    button.setAttribute('role', 'radio');
    button.removeAttribute('aria-pressed');
    button.setAttribute('aria-checked', String(isSelected(button)));
    button.tabIndex = isSelected(button) || (!buttons.some(isSelected) && index === 0) ? 0 : -1;
  });
}

function enableArrowKeys(group) {
  if (group.dataset.waKeyboard === 'true') return;
  group.dataset.waKeyboard = 'true';
  group.addEventListener('keydown', (event) => {
    if (!['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(event.key)) return;
    const buttons = [...group.querySelectorAll('[role="radio"]')];
    if (!buttons.length) return;
    const current = Math.max(0, buttons.indexOf(document.activeElement));
    let next = current;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % buttons.length;
    else next = (current - 1 + buttons.length) % buttons.length;
    event.preventDefault();
    buttons[next].focus();
    buttons[next].click();
  });
}

function normalizeCopy(root) {
  root.querySelectorAll('button').forEach((button) => {
    const text = button.textContent.trim();
    if (text === 'COMPRAR AGORA') button.textContent = 'Comprar agora';
    if (text === 'ADICIONAR AO CARRINHO') button.textContent = 'Adicionar ao carrinho';
  });
}

function enhanceUploads(root) {
  root.querySelectorAll(UPLOAD_ICON_SELECTOR).forEach((icon) => {
    if (!icon.querySelector('svg')) icon.innerHTML = uploadIcon;
  });
}

function enhanceLiveRegions(root) {
  root.querySelectorAll('[class*="-erro"],[class*="-error"]').forEach((node) => {
    node.setAttribute('role', 'alert');
    node.setAttribute('aria-live', 'assertive');
  });
  root.querySelectorAll('[class*="-total"],[data-wc-price],[data-wa-price]').forEach((node) => {
    node.setAttribute('aria-live', 'polite');
  });
}

function enhanceValidation(root) {
  root.addEventListener('invalid', (event) => {
    const control = event.target;
    control.setAttribute('aria-invalid', 'true');
    requestAnimationFrame(() => control.focus({preventScroll: false}));
  }, true);
  root.addEventListener('input', (event) => {
    if (event.target.matches('input,textarea,select') && event.target.checkValidity?.()) {
      event.target.removeAttribute('aria-invalid');
    }
  });
  root.querySelectorAll('[class*="-erro"],[class*="-error"]').forEach((error) => {
    const observe = () => {
      if (error.hidden || !error.textContent.trim() || !error.getClientRects().length) return;
      error.tabIndex = -1;
      const invalid = root.querySelector('[aria-invalid="true"],:invalid');
      if (invalid instanceof HTMLElement) invalid.focus({preventScroll: false});
      else error.focus({preventScroll: false});
    };
    new MutationObserver(observe).observe(error, {attributes:true,attributeFilter:['hidden','class'],childList:true,characterData:true,subtree:true});
  });
}

function fieldLabel(control) {
  const explicit = control.id && document.querySelector(`label[for="${CSS.escape(control.id)}"]`);
  const wrapped = control.closest('label');
  const nearby = control.closest('[class*="field"],[class*="upload"],[class*="step"]')?.querySelector('label,strong,h3');
  return (explicit || wrapped || nearby)?.textContent?.trim().replace(/\s+/g, ' ') || '';
}

function enhanceFieldLabels(root) {
  root.querySelectorAll('input,textarea,select').forEach((control) => {
    if (control.type === 'hidden' || control.getAttribute('aria-label') || control.getAttribute('aria-labelledby')) return;
    if (control.id && document.querySelector(`label[for="${CSS.escape(control.id)}"]`)) return;
    if (control.closest('label')) return;
    const label = fieldLabel(control) || control.placeholder || control.name?.replace(/^properties\[|\]$/g, '') || 'Campo de personalização';
    control.setAttribute('aria-label', label);
  });
}

function activeGalleryImage(root) {
  const gallery = root.querySelector(GALLERY_SELECTOR);
  if (!gallery) return null;
  const images = [...gallery.querySelectorAll('img')].filter((image) => {
    if (image.closest('button,[class*="thumb"],[hidden]')) return false;
    const style = getComputedStyle(image);
    const rect = image.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 120 && rect.height > 120;
  });
  return images.find((image) => image.closest('[class*="active"],[class*="on"],[class*="stage"],[class*="main"]')) || images[0] || null;
}

function currentPrice(root) {
  const nodes = [...root.querySelectorAll('[class*="total"],[class*="price"],[data-wc-price],[data-wa-price]')];
  for (const node of nodes.reverse()) {
    const match = node.textContent.match(/R\$\s*[\d.]+(?:,\d{2})?/);
    if (match) return match[0];
  }
  return '';
}

function currentChoices(root) {
  const choices = [];
  root.querySelectorAll('[role="radio"][aria-checked="true"],button.is-active,button.is-on').forEach((control) => {
    if (control.closest('[class*="thumb"]')) return;
    const text = (control.dataset.nome || control.getAttribute('aria-label') || control.querySelector('strong,b')?.textContent || control.querySelector('span')?.textContent || control.textContent).trim().replace(/\s+/g, ' ');
    if (text && text.length <= 90) choices.push(text);
  });
  root.querySelectorAll('input:checked').forEach((control) => {
    const text = (fieldLabel(control) || '').split(/(?=[A-ZÁÉÍÓÚ][a-záéíóú]{3,})/)[0].trim();
    if (text) choices.push(text);
  });
  root.querySelectorAll('input:not([type]),input[type="text"],textarea,select').forEach((control) => {
    if (!control.value?.trim()) return;
    const label = fieldLabel(control) || control.getAttribute('aria-label');
    if (label) choices.push(`${label}: ${control.value.trim()}`);
  });
  return [...new Set(choices)].slice(0, 8);
}

function updateChoiceSummary(root, summary) {
  const image = activeGalleryImage(root);
  const imageNode = summary.querySelector('.wa-choice-summary__image');
  if (image) {
    imageNode.src = image.currentSrc || image.src;
    imageNode.alt = '';
    imageNode.hidden = false;
  } else imageNode.hidden = true;
  const choices = currentChoices(root);
  summary.querySelector('.wa-choice-summary__choices').textContent = choices.length ? choices.join(' · ') : 'Selecione as opções para visualizar a configuração.';
  summary.querySelector('.wa-choice-summary__price').textContent = currentPrice(root);
}

function enhanceChoiceSummary(root) {
  if (root.querySelector('.wa-choice-summary')) return;
  const buybox = root.querySelector(BUYBOX_SELECTOR);
  if (!buybox) return;
  const summary = document.createElement('section');
  summary.className = 'wa-choice-summary';
  summary.setAttribute('aria-label', 'Resumo da configuração');
  summary.setAttribute('aria-live', 'polite');
  summary.innerHTML = '<img class="wa-choice-summary__image" alt=""><div class="wa-choice-summary__content"><strong class="wa-choice-summary__title">Sua configuração</strong><p class="wa-choice-summary__choices"></p></div><strong class="wa-choice-summary__price"></strong>';
  const summaryAnchor = root.querySelector('[data-wa-choice-summary-anchor]');
  if (summaryAnchor) summaryAnchor.before(summary);
  else buybox.before(summary);
  updateChoiceSummary(root, summary);
  let queued = false;
  const queueUpdate = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; updateChoiceSummary(root, summary); });
  };
  root.addEventListener('input', queueUpdate);
  root.addEventListener('change', queueUpdate);
  root.addEventListener('click', () => setTimeout(queueUpdate));
  new MutationObserver(queueUpdate).observe(root, {subtree: true, attributes: true, attributeFilter: ['class','aria-checked']});
}

let zoomDialog;
let zoomItems = [];
let zoomIndex = 0;
let zoomTrigger = null;

function ensureZoomDialog() {
  if (zoomDialog) return zoomDialog;
  zoomDialog = document.createElement('dialog');
  zoomDialog.className = 'wa-media-dialog';
  zoomDialog.setAttribute('aria-label', 'Visualização ampliada do produto');
  zoomDialog.innerHTML = '<button class="wa-media-dialog__close" type="button" aria-label="Fechar">×</button><button class="wa-media-dialog__prev" type="button" aria-label="Imagem anterior">‹</button><figure class="wa-media-dialog__figure"><img class="wa-media-dialog__image" alt=""><figcaption class="wa-media-dialog__caption"></figcaption></figure><button class="wa-media-dialog__next" type="button" aria-label="Próxima imagem">›</button>';
  document.body.append(zoomDialog);
  zoomDialog.querySelector('.wa-media-dialog__close').addEventListener('click', () => zoomDialog.close());
  zoomDialog.querySelector('.wa-media-dialog__prev').addEventListener('click', () => showZoom(zoomIndex - 1));
  zoomDialog.querySelector('.wa-media-dialog__next').addEventListener('click', () => showZoom(zoomIndex + 1));
  zoomDialog.addEventListener('close', () => zoomTrigger?.focus());
  return zoomDialog;
}

function showZoom(index) {
  if (!zoomItems.length) return;
  zoomIndex = (index + zoomItems.length) % zoomItems.length;
  const item = zoomItems[zoomIndex];
  const dialog = ensureZoomDialog();
  const image = dialog.querySelector('.wa-media-dialog__image');
  image.src = item.currentSrc || item.src;
  image.alt = item.alt || 'Imagem ampliada do produto';
  dialog.querySelector('.wa-media-dialog__caption').textContent = item.alt || '';
  const hideNavigation = zoomItems.length < 2;
  dialog.querySelector('.wa-media-dialog__prev').hidden = hideNavigation;
  dialog.querySelector('.wa-media-dialog__next').hidden = hideNavigation;
}

function galleryImages(root) {
  const gallery = root.querySelector(GALLERY_SELECTOR);
  if (!gallery) return [];
  return [...gallery.querySelectorAll('img')].filter((image) => {
    if (image.closest('button,[class*="thumb"],label,[hidden]')) return false;
    const style = getComputedStyle(image);
    const rect = image.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 120 && rect.height > 120;
  });
}

function openZoom(root, image) {
  openZoomItems(galleryImages(root), image);
}

function openZoomItems(items, image) {
  zoomItems = items;
  zoomIndex = Math.max(0, zoomItems.indexOf(image));
  zoomTrigger = image;
  showZoom(zoomIndex);
  ensureZoomDialog().showModal();
}

function enhanceZoom(root) {
  galleryImages(root).forEach((image) => {
    if (image.dataset.waZoom === 'true') return;
    image.dataset.waZoom = 'true';
    image.classList.add('wa-zoomable');
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', `${image.alt || 'Imagem do produto'}. Abrir imagem ampliada`);
    image.addEventListener('click', () => openZoom(root, image));
    image.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openZoom(root, image);
    });
  });
}

function enhanceComplementZoom() {
  document.querySelectorAll('.wc-adds,.wcs-comps').forEach((group) => {
    const images = [...group.querySelectorAll('img')];
    images.forEach((image) => {
      if (image.dataset.waZoom === 'true') return;
      image.dataset.waZoom = 'true';
      image.classList.add('wa-zoomable');
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', `${image.alt || 'Imagem do complemento'}. Abrir imagem ampliada`);
      image.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); openZoomItems(images, image); });
      image.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        openZoomItems(images, image);
      });
    });
  });
}

function normalizeEditorialOrder() {
  const stories = document.querySelectorAll('.wcs,.cs,.chs,.wkps,.ks,.lcs,.ps,.wa-story-sec,.wbs,.bs,.wxms');
  stories.forEach((story) => {
    const blocks = [...story.children];
    const text = node => (node.textContent || '').trim().replace(/\s+/g, ' ');
    const faq = blocks.find(node => /DÚVIDAS FREQUENTES|PERGUNTAS FREQUENTES|Antes de (encomendar|montar|gravar)/i.test(text(node)));
    if (!faq) return;
    const authority = blocks.find(node => /QUEM ESCOLHE A WE ART|anos de ateliê|produção no ateliê|depoimento de cliente/i.test(text(node)));
    const complements = blocks.find(node => /COMPLETE (A PAPELARIA|SEU PEDIDO)|Itens que combinam|COMPLEMENTOS RELACIONADOS/i.test(text(node)));
    /* O Cartão Social tem uma sequência editorial própria: os complementos
       contextualizados vêm após a personalização e antes da ficha/FAQ. */
    if (story.matches('.wcs')) return;
    if (authority && authority !== faq) story.insertBefore(authority, faq);
    if (complements && complements !== faq) faq.after(complements);
  });
}

function enhance(root) {
  document.body.classList.add('wa-product-system');
  initializeMirror(root);
  initializeClinicIndividual(root);
  normalizeCopy(root);
  enhanceUploads(root);
  enhanceLiveRegions(root);
  enhanceValidation(root);
  enhanceFieldLabels(root);
  enhanceChoiceSummary(root);
  enhanceZoom(root);
  root.querySelectorAll(RADIO_GROUP_SELECTOR).forEach((group) => {
    syncRadioGroup(group);
    enableArrowKeys(group);
  });
}

function boot() {
  const roots = [...document.querySelectorAll(ROOT_SELECTOR)];
  if (!roots.length) return;
  roots.forEach(enhance);
  normalizeEditorialOrder();
  enhanceComplementZoom();

  const observer = new MutationObserver((mutations) => {
    const groups = new Set();
    mutations.forEach((mutation) => {
      const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
      const group = target?.closest?.(RADIO_GROUP_SELECTOR);
      if (group) groups.add(group);
    });
    groups.forEach(syncRadioGroup);
    roots.forEach((root) => enhanceZoom(root));
  });
  roots.forEach((root) => observer.observe(root, {subtree: true, attributes: true, attributeFilter: ['class']}));
}

const MOBILE_STICKY_CTA_SELECTOR = [
  '[data-wci-add]', '[data-wam-add]', '[data-wgp-add]', '[data-wkc-add]',
  '[data-wkp-add]', '[data-wog-add]', '[data-womg-add]', '[data-wol-add]',
  '[data-wxm-add]', '[data-wc-cta]'
].join(',');

const LEGACY_STICKY_SELECTOR = [
  '[data-wa-sticky]', '.cx-sticky', '.cr-sticky', '.kc-sticky', '.ke-sticky',
  '.pl-sticky', '.br-sticky', '.wa-sticky'
].join(',');

const mobileStickyMedia = window.matchMedia('(max-width: 959px)');

function initializeMobileStickyCta() {
  if (!mobileStickyMedia.matches) {
    document.body.classList.remove('wa-mobile-cta-active');
    return;
  }

  document.querySelectorAll(MOBILE_STICKY_CTA_SELECTOR).forEach((source) => {
    if (!(source instanceof HTMLButtonElement) || source.dataset.waStickyReady === 'true') return;
    const scope = source.closest('section, [data-wci], [data-wam], [data-wgp], [data-wkc], [data-wkp], [data-wog], [data-womg], [data-wol], [data-wxm]');
    if (!scope || scope.querySelector(LEGACY_STICKY_SELECTOR)) return;

    source.dataset.waStickyReady = 'true';
    const bar = document.createElement('div');
    bar.className = 'wa-mobile-sticky-cta';
    bar.setAttribute('aria-hidden', 'true');
    const isCartaoSocial = source.matches('[data-wc-cta]');
    bar.innerHTML = `${isCartaoSocial ? '<span class="wa-mobile-sticky-cta__price" data-wa-mobile-price hidden></span>' : ''}<button type="button" class="wa-cta-primary wa-mobile-sticky-cta__button">Adicionar ao carrinho</button>`;
    const button = bar.querySelector('button');
    if (!(button instanceof HTMLButtonElement)) return;
    const price = bar.querySelector('[data-wa-mobile-price]');

    const sync = () => {
      button.disabled = source.disabled || source.getAttribute('aria-busy') === 'true';
      button.textContent = source.textContent.trim() || 'Adicionar ao carrinho';
      button.setAttribute('aria-label', button.textContent);
      if (price instanceof HTMLElement) {
        const value = scope.querySelector('[data-wc-total]')?.textContent?.trim() || '';
        price.textContent = value;
        price.hidden = !value;
      }
    };
    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('wa-mobile-cta-active', visible);
    };

    sync();
    document.body.append(bar);
    const sourceObserver = new MutationObserver(sync);
    sourceObserver.observe(source, { attributes: true, childList: true, subtree: true, characterData: true, attributeFilter: ['disabled', 'aria-busy', 'class'] });
    if (price instanceof HTMLElement) {
      const total = scope.querySelector('[data-wc-total]');
      if (total) new MutationObserver(sync).observe(total, { childList: true, subtree: true, characterData: true });
    }

    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && mobileStickyMedia.matches);
    }, { threshold: 0.15 });
    observer.observe(source);

    button.addEventListener('click', () => {
      if (source.disabled) {
        source.scrollIntoView({ behavior: 'smooth', block: 'center' });
        source.focus({ preventScroll: true });
        return;
      }
      source.click();
    });
  });
}

/* Shared mobile preview shortcut. Product adapters only declare the preview
   target and the fields that change it; the fixed control and its behavior
   remain in the product system so the purchase flow is never reordered. */
function initializeMobilePreviewJumps() {
  document.querySelectorAll('[data-wa-mobile-preview-source]').forEach((source) => {
    if (!(source instanceof HTMLElement) || source.dataset.waPreviewReady === 'true') return;
    const targetSelector = source.dataset.waPreviewTarget;
    const inputsSelector = source.dataset.waPreviewInputs;
    if (!targetSelector || !inputsSelector) return;

    const target = document.querySelector(targetSelector);
    const inputs = [...document.querySelectorAll(inputsSelector)].filter((input) => input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement || input instanceof HTMLSelectElement);
    if (!(target instanceof HTMLElement) || !inputs.length) return;

    source.dataset.waPreviewReady = 'true';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wa-mobile-preview-jump';
    button.textContent = source.dataset.waPreviewLabel || 'Ver sua personalização';
    button.setAttribute('aria-hidden', 'true');
    button.setAttribute('aria-label', button.textContent);
    button.tabIndex = -1;
    document.body.append(button);

    let previewVisible = true;
    const previewRoot = source.closest('[data-wam], [data-wa-product-root]');
    const syncTop = () => {
      const header = document.querySelector('.header-section');
      const headerBottom = header instanceof HTMLElement ? header.getBoundingClientRect().bottom : 60;
      button.style.setProperty('--wa-mobile-preview-top', `${Math.max(8, Math.ceil(headerBottom + 12))}px`);
    };
    const hasPersonalization = () => inputs.some((input) => {
      if (input instanceof HTMLInputElement && input.type === 'file') return input.files?.length;
      return Boolean(input.value.trim());
    });
    const sync = () => {
      const visible = mobileStickyMedia.matches && hasPersonalization() && !previewVisible;
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
      previewRoot?.classList.toggle('wa-mobile-preview-active', visible);
      document.body.classList.toggle('wa-mobile-preview-active', Boolean(document.querySelector('.wa-mobile-preview-jump.is-visible')));
      syncTop();
    };

    inputs.forEach((input) => {
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
    });
    mobileStickyMedia.addEventListener('change', sync);
    window.addEventListener('resize', syncTop, { passive: true });

    new IntersectionObserver(([entry]) => {
      previewVisible = entry.isIntersecting;
      sync();
    }, { threshold: 0.2 }).observe(target);

    button.addEventListener('click', () => {
      const targetRect = target.getBoundingClientRect();
      const destination = Math.max(0, targetRect.top + window.scrollY - Math.max(16, (window.innerHeight - targetRect.height) / 2));
      window.scrollTo({ top: destination, behavior: 'instant' });
      previewVisible = true;
      sync();
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({event: 'personalization_preview_open', product_type: 'espelho_de_mao'});
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      window.setTimeout(() => target.focus({ preventScroll: true }), 0);
    });

    sync();
  });
}

function bootProductSystem() {
  boot();
  initializeMobileStickyCta();
  initializeMobilePreviewJumps();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootProductSystem, {once: true});
else bootProductSystem();

document.addEventListener('shopify:section:load', () => {
  initializeMobileStickyCta();
  initializeMobilePreviewJumps();
});
mobileStickyMedia.addEventListener('change', () => {
  initializeMobileStickyCta();
  initializeMobilePreviewJumps();
});
